import { render, staticRenderFns } from "./AdminJson.vue?vue&type=template&id=7562516d&"
import script from "./AdminJson.vue?vue&type=script&lang=js&"
export * from "./AdminJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports